import { api } from './client';

export const AnalyticsAPI = {
  softwareSummary: (params) => api.get('/analytics/software', { params }), // { byVendor, byName, ... }
  softwareAudit: () => api.get('/analytics/software/audit'),
  softwareFamilies: () => api.get('/analytics/software/families'),
  softwareWorkbook: () => api.get('/analytics/software/workbook', { responseType: 'blob' }),
};
